'use strict';

module.exports = {
    STORAGE_PROFILE_CREATED: 'com.signiant.storageProfile.created',
    STORAGE_PROFILE_DELETED: 'com.signiant.storageProfile.deleted'
};